import React, { useEffect, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

const toInputDate = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().split("T")[0];
};

const formatDate = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toLocaleDateString("en-GB");
};

const formatTime = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    const asString = String(value);
    if (asString.includes("T")) {
      const t = asString.split("T")[1] || "";
      return t.split(".")[0] || "-";
    }
    return asString;
  }
  return parsed.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

const AdmMOUList = () => {
  const navigate = useNavigate();
  const [mouData, setMouData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const today = useMemo(() => new Date().toISOString().split("T")[0], []);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const academicSessionId = localStorage.getItem("academicSessionId");
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");

  const fetchMouDetails = async () => {
    if (!academicSessionId || !orgId || !branchId) {
      setMouData([]);
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(
        `${ApiUrl.apiurl}MOU/MouDetailsList/${academicSessionId}/${orgId}/${branchId}/`
      );
      const data = await response.json().catch(() => ({}));

      if (response.ok && data.message === "success" && Array.isArray(data.data)) {
        setMouData(data.data);
      } else {
        setMouData([]);
      }
    } catch (error) {
      console.error("Error fetching MOU details:", error);
      setMouData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMouDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [academicSessionId, orgId, branchId]);

  const filteredData = mouData.filter((item) => {
    const sourceDate =
      item.upload_date ||
      item.mou_date ||
      item.created_at ||
      item.date ||
      item.createdDate ||
      null;
    const itemDate = toInputDate(sourceDate);
    if (!itemDate) return true;
    if (fromDate && itemDate < fromDate) return false;
    if (toDate && itemDate > toDate) return false;
    return true;
  });

  const handleClear = () => {
    setFromDate(today);
    setToDate(today);
  };

  const handleDelete = async (id) => {
    if (!id) return;
    const confirmDelete = window.confirm("Are you sure you want to delete this record?");
    if (!confirmDelete) return;

    try {
      const response = await fetch(`${ApiUrl.apiurl}MOU/deleteMouDetails/${id}/`, {
        method: "DELETE",
      });

      if (response.ok) {
        setMouData((prev) => prev.filter((row) => row.mou_id !== id));
      } else {
        alert("Failed to delete record.");
      }
    } catch (error) {
      console.error("Error deleting MOU detail:", error);
      alert("Error deleting MOU detail.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                SEARCH MOUs
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={fetchMouDetails}
                    disabled={isLoading}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{ width: "150px" }}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-2 mb-4 mx-2">
                <div
                  className="col-12 custom-section-box"
                  style={{ paddingTop: "10px" }}
                >
                  <div className="row mb-4 ">
                    <div className="col-md-3 mb-2 ">
                      <label className="fw-bold">From Date</label>
                      <input
                        type="date"
                        className="form-control detail"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3 mb-2 ">
                      <label className="fw-bold">To Date</label>
                      <input
                        type="date"
                        className="form-control detail"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>MOU Date</th>
                        <th>MOU Time</th>
                        <th>Details</th>
                        <th>Document</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((item, index) => {
                          const dateSource =
                            item.upload_date ||
                            item.mou_date ||
                            item.created_at ||
                            item.date ||
                            item.createdDate;
                          const timeSource =
                            item.upload_time || item.created_at;
                          const filePath =
                            item.upload_file ||
                            item.file ||
                            item.document ||
                            item.doc_file ||
                            item.doc_path;

                          const fileUrl = filePath
                            ? filePath.startsWith("http")
                              ? filePath
                              : `${ApiUrl.apiurl.replace("/api/", "/")}${filePath}`
                            : "";

                          return (
                            <tr key={item.mou_id || index}>
                              <td>{index + 1}</td>
                              <td>{formatDate(dateSource)}</td>
                              <td>{formatTime(timeSource)}</td>
                              <td>{item.mou_details || "-"}</td>
                              <td>
                                {fileUrl ? (
                                  <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View
                                  </a>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                              <td>
                                <a
                                  href="#"
                                  className="text-danger"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDelete(item.mou_id);
                                  }}
                                >
                                  Delete
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center text-danger">
                            {isLoading ? "Loading..." : "No record found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmMOUList;
